export let config = {
    page_id: typeof document.body.getAttribute('data-pid') !== "undefined" ?
        parseInt(document.body.getAttribute('data-pid')) : 0,

    method: typeof document.body.getAttribute('data-method') !== "undefined" ?
        document.body.getAttribute('data-method').toString() : "",
    p: typeof document.body.getAttribute('data-p') !== "undefined" ?
        parseInt(document.body.getAttribute('data-p')) : 0,

    lang: typeof document.body.getAttribute('data-lang') !== "undefined" ?
        document.body.getAttribute('data-lang') : "ru",

        template: '/templates/childnew/',

    suffix: "руб",
    confirmBtn: 'btn',
    alertCloseIconClass: 'ti ti-close',
    debug: true,
}